<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <!-- <router-link to="/">
          <img
            class="pt-5 img-fluid"
            src="../assets/imgs/homecapistrano/texto-1.png"
            alt="Copa Prosa"
          />
        </router-link> -->
      </div>

      <div class=""></div>
    </section>

    <section id="preguntas-frecuentes" class="pt-5 pb-5 z1000 bgfaqs">
      <div class="d-lg-block py-5">&nbsp;</div>
      <div class="d-none d-lg-block py-5">&nbsp;</div>
     
      <div class="d-none d-xl-block py-5">&nbsp;</div>
      <div class="d-none d-xl-block py-5">&nbsp;</div>
      <div class="d-lg-block py-4">&nbsp;</div>
      
      <div class="container pb-5">
        <div class="row py-5" data-aos="fade-up" data-aos-delay="500">
          <div class="col-md-12 text-center pb-4 verde fXG pt-5 mt-5 ls3">
            PREGUNTAS FRECUENTES
          </div>

          <div class="col-10 offset-2 col-lg-10 offset-lg-1 order-2 order-md-1">
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-1 variant=""
                    >¿Cómo llegar a Bosque Real?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg
                    ></span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Puedes llegar al club por la carretera Chamapa y tomas la
                      salida de Bosque Real (uso de TAG obligatorio) o por la
                      vialidad Interlomas-Bosque Real. Entrando a Bosque Real
                      sigue las señalizaciones de Copa Prosa. Consulta aquí la
                      ubicación:
                      <a
                        href="https://goo.gl/maps/dxwQwQpVu5dq4UFaA"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://goo.gl/maps/dxwQwQpVu5dq4UFaA</a
                      >
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-2 variant=""
                    >¿Dónde dejo mi auto?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Para ingresar a Bosque Real deberás presentar en caseta tu código QR de acceso junto con una identificación oficial  y dejar tu auto en el valet parking; es gratuito y estará disponible durante
                      todo el día.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-3 variant=""
                    >¿Dónde dejo mis cosas?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Los lockers están pasando el área de registro.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-4 variant=""
                    >¿Cómo se juega el formato bola baja de parejas Stableford?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      <p>
                        Los 2 jugadores deberán de jugar su bola de manera
                        individual y cada uno obtendrá el 70% de su hándicap en
                        las ventajas del campo.
                      </p>
                      <p>
                        Los jugadores competirán con su score neto, mismo que
                        será contabilizado con la tabla de puntos de stableford
                        y contará la bola baja. La competencia se sancionará por
                        la cantidad más alta de puntos obtenidos en 2
                        categorías.
                      </p>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-5 variant=""
                    >¿El torneo incluye carritos de golf?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-5"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Sí, tenemos asignados 2 carritos para cada foursome. Un
                      jugador del equipo compartirá el carrito con un jugador
                      del equipo contrario.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-6 variant=""
                    >¿Cómo es la política de los caddies?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-6"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      1 caddie por jugador y la cuota de caddie es pagada por
                      Prosa.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-7 variant=""
                    >¿Cuánto tiempo antes debo llegar a la clínica?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-7"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Te sugerimos llegar 30 minutos antes del horario de la
                      clínica.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-8 variant=""
                    >¿Cómo debo de ir vestido a la clínica?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-8"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Playera tipo polo, pantalón casual (no mezclilla), gorra y
                      tenis.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-9 variant=""
                    >¿Tengo bastones para la clínica, los debo llevar?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-9"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Sí, puedes traer tus bastones de golf, en caso de que no
                      tengas nosotros te proporcionaremos.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-10 variant=""
                    >¿Qué hacer terminando la clínica?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-10"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Terminando la clínica te invitamos al snack.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-11 variant=""
                    >¿Dónde es la comida de premiación?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-11"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      La comida de premiación es en el jardín principal de
                      Bosque Real.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-12 variant=""
                    >¿A qué hora cierran los lockers?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-12"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      Los Lockers cierran a las 4 pm, puedes retirar tus cosas y
                      dejarlas en el valet parking para que las guarden en tu
                      auto o dejarlas en el guardarropa de la comida de
                      premiación.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-13 variant=""
                    >¿En dónde me entregan mi auto?
                    <span>
                      <svg
                        height="512px"
                        id="Layer_1"
                        style="enable-background: new 0 0 512 512"
                        version="1.1"
                        viewBox="0 0 512 512"
                        width="512px"
                        xml:space="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9  c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3  z"
                        /></svg></span
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-13"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text class="negro">
                      En el área de valet de la comida de premiación.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 py-5">&nbsp;</div>
      
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNavSpecial";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      loginForm: {
        no_cliente: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        password: "",
        estado: "",
        no_cliente: "",
        telefono: "",
        movil: "",
        codigo_pais: "",
        talla: "",
        talla_cubrebocas: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_copaprosa2021",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: this.signupForm.nombre,
        apellido: this.signupForm.apellido,
        email: this.signupForm.email,
        password: this.signupForm.password,
        no_cliente: this.signupForm.no_cliente,
        estado: this.signupForm.estado,
        telefono: this.signupForm.telefono,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
              this.toggleForm();
            } else if (res.status === "correo") {
              swal.fire("Registro", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        password: "",
        estado: "",
        no_cliente: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
